import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {};

const databankSlice = createSlice({
  name: "databank",
  initialState,
  reducers: {
    setDatabankData: (state: any, action: PayloadAction<any>) => {
      const { id, fileVersionId, data } = action.payload;
      if (!state[id]) state[id] = {};
      state[id][fileVersionId] = {
        ...(state[id][fileVersionId] || {}),
        ...data,
      };
    },
    updateCurrentDatabankView: (state: any, action: PayloadAction<any>) => {
      const { id, fileVersionId, data } = action.payload;
      const currentSelectedView = state[id]?.[fileVersionId]?.selectedView;
      if (!currentSelectedView) return;
      state[id][fileVersionId] = {
        ...(state[id]?.[fileVersionId] || {}),
        views: {
          ...state[id][fileVersionId].views,
          [currentSelectedView]: {
            ...state[id][fileVersionId].views[currentSelectedView],
            ...data,
          },
        },
      };
    },
    resetDatabank: (state: any, action: PayloadAction<any>) => {
      const { id, fileVersionId } = action.payload;
      if (!state[id]) state[id] = {};
      state[id][fileVersionId] = {};
    },
  },
});

export const { setDatabankData, updateCurrentDatabankView, resetDatabank } = databankSlice.actions;
export const Databank = databankSlice.reducer;
export default databankSlice.reducer;
